import eventQueue from '../queue';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var data = _a.data;
        if (data.eventId === 'DDForm-selectSignature') {
            /*
            fireAnalyticsEvent(
              EventAction.SELECT_SIGNATURE,
              {
                signature: state.ddForm.signatureStyle,
              },
              EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT
            );
            */
        }
    });
}
attachEventListeners();
